import React from 'react';
import { EmptyApplicationFlush } from '../../app/EmptyApplication';
import { PageContainer } from 'shared/components/PageContainer';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { NextButton, SubmitButtons } from 'shared/components/SubmitButtons';
import { PageHeading } from 'shared/components/typography';
import { App_PortalFragment, Cart_ApplicationFragment, useClearApplicationWarningsMutation } from '../../generated.graphql';
import { useMediaBreakpoints } from 'shared/media';
import { RentalStepProps } from 'rental/app/steps';
import styles from './Cart.module.scss';
import { CartStack } from './CartStack';
import { CartTable } from './CartTable';
import { RebatePeriodSelect } from './RebatePeriodSelect';
 

interface Props extends RentalStepProps {
  application: Cart_ApplicationFragment;
  portal: App_PortalFragment
}


export const Cart = (props: Props) => {
  const { application, portal } = props;
  const media = useMediaBreakpoints();
  const [updateWarningsResult, executeClearWarnings] = useClearApplicationWarningsMutation();

  const clearWarnings = async () => {
    // don't bother calling if we don't have mixed rates
    if (application.hasMixedRates) {
      await executeClearWarnings({ input: { portalSlug: portal.slug }});
    }
  }
  
  if ((application.items?.length || 0) > 0) {
    const hasImage = (application.items?.filter(item => item.imageUrl).length || 0) > 0;
    const isNotInStore = !application.inStore;
    const firstItem = application.items ? application.items[0] : undefined;
    return (
      <>
        <PageContainer extraClassName={styles.Cart}>
          <RentalPageTitleHelmet>Cart</RentalPageTitleHelmet>
          <PageHeading className="mb-4">
            <span className="mr-4">You have {application.items?.length} item{application.items?.length === 1 ? '' : 's'} in your cart</span>
            {/* <RebatePeriodSelect application={application}/> */}
          </PageHeading>

          {/* {application.hasMixedRates && (
            <div className="alert alert-warning text-center my-3" role="alert">
              Please note: All items on an application must have the same minimum rental period, therefore we have updated the items in your cart to reflect this.
              <button type="button" className="close" disabled={updateWarningsResult?.fetching} aria-label="Close" onClick={clearWarnings}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          )} */}

          {(media.mdGTE) ? 
            <CartTable application={application} portal={props.portal} className="mb-5" columns={{
              image: hasImage, 
              condition: isNotInStore, 
              quantity: isNotInStore || ((application.items?.length ?? 0) >= 2) || firstItem?.qty !== 1, 
              remove: isNotInStore,
            }}/> 
          : 
            <CartStack application={application} portal={props.portal} className="mb-5" remove={isNotInStore}/>
          }
          {/* {application.protectionPlan && 
            <ProtectionPlan application={application} className="shadow px-2 py-3 mb-4"/>
          } */}
          {application.inStore &&
            <p>
              <em>Note:</em> If you would like to change your application please contact the retailer.
            </p>
          }
        </PageContainer>
        
        <PageContainer>
          {application.validation.cart?.map((e, ei) => (
            <React.Fragment key={ei}>
              {e?.messages.map((m, mi) => (
                <div key={mi} className="alert alert-danger text-center my-3">{m}</div>
              ))}
            </React.Fragment>
          ))}
          
          <SubmitButtons
            xsStack={true}
            left={!application.inStore && application.portal.portalUrl &&
              <a className="btn btn-outline-secondary btn-wide w-100 w-sm-auto" href={application.portal.portalUrl}>Continue Shopping</a>
            }
            right={
              <NextButton
                className="w-100 w-sm-auto"
                onClick={async () => {
                  // This is a combined mutation that clears warnings and records an interaction
                  await clearWarnings();
                  props.onSubmitSuccessful();
                }}
                disabled={(application.validation.cart !== null)}
              >
                Begin Application
              </NextButton>
            }
          />
        </PageContainer>
      </>
    )
  }
  
  return (
    <EmptyApplicationFlush portal={props.portal}/>
  )
};

